import { Col, Row } from "antd";
import SideNav from "./SideNav";
import { DashboardProvider } from "../../Context/DashboardContext";
import { useEffect, useState } from "react";
import DashboardContent from "./DashboardContent";
import RoundsDrawer from "./RoundsDrawer";
import { useLocation } from "react-router-dom";
import "./index.scss";

const Dashboard = () => {
  const location = useLocation();
  const [drawerVisible, setDrawerVisible] = useState(false);

  const handleOpenRoundsDrawer = () => {
    setDrawerVisible(true);
  };

  const handleCloseRoundsDrawer = () => {
    setDrawerVisible(false);
  };

  // Close round drawer when navigating to a different page
  useEffect(() => {
    setDrawerVisible(false);
  }, [location.pathname]);

  return (
    <DashboardProvider>
      <section className="dashboard_base_container">
        <Row style={{ height: "100%" }}>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 8 }}
            lg={{ span: 6 }}
            xl={{ span: 4 }}
            style={{ height: "100%" }}
            className="dashboard_sider_col"
          >
            <SideNav />
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 16 }}
            lg={{ span: 18 }}
            xl={{ span: 20 }}
            style={{ height: "100%" }}
          >
            <div className="dashboard_content">
              <DashboardContent onRoundsButtonClick={handleOpenRoundsDrawer} />
            </div>
          </Col>
        </Row>
      </section>
      <RoundsDrawer
        handleDrawerClose={handleCloseRoundsDrawer}
        isOpen={drawerVisible}
      />
    </DashboardProvider>
  );
};

export default Dashboard;
